module.exports = __webpack_public_path__ + "img/hero_polis.27b88822.svg";